import { CloseIcon } from '@oneToOne/shared/assets/CloseIcon'
import {
  iconDropShadowCss,
  iconOnlyCss,
  OtoButton,
  type OtoButtonProps,
} from '@oneToOne/shared/components/buttons/OtoButton'
import { CLOSE_BUTTON } from '@oneToOne/shared/testIds'

import { useContextTranslation } from '@core/i18n'
import { useTwindContext } from '@core/twind'

interface CloseButtonProps extends OtoButtonProps {
  iconClassName?: string
}
/**
 * Generic close button.
 */
export function CloseButton({
  variant,
  iconClassName,
  ...rest
}: CloseButtonProps) {
  const { t } = useContextTranslation()
  const { tw } = useTwindContext()
  return (
    <OtoButton
      overrideCSS={iconOnlyCss}
      aria-label={t('Close')}
      data-testid={CLOSE_BUTTON}
      {...rest}
    >
      <CloseIcon
        width="16px"
        height="16px"
        stroke={variant === 'secondary' ? 'var(--blk2)' : 'var(--white)'}
        className={tw?.(
          variant === 'secondary' ? '' : iconDropShadowCss,
          iconClassName,
        )}
        label=""
        aria-hidden
      />
    </OtoButton>
  )
}
